import { removeItem } from '@varlet/shared';
import { getCurrentInstance, computed, provide, reactive, isVNode, } from 'vue';
function flatVNodes(subTree) {
    const vNodes = [];
    const flat = (subTree) => {
        if (subTree === null || subTree === void 0 ? void 0 : subTree.component) {
            flat(subTree === null || subTree === void 0 ? void 0 : subTree.component.subTree);
            return;
        }
        if (Array.isArray(subTree === null || subTree === void 0 ? void 0 : subTree.children)) {
            subTree.children.forEach((child) => {
                if (isVNode(child)) {
                    vNodes.push(child);
                    flat(child);
                }
            });
        }
    };
    flat(subTree);
    return vNodes;
}
export function useChildren(key) {
    const parentInstance = getCurrentInstance();
    const childInstances = reactive([]);
    const childProviders = [];
    const length = computed(() => childInstances.length);
    const sortInstances = () => {
        const vNodes = flatVNodes(parentInstance.subTree);
        childInstances.sort((a, b) => {
            return vNodes.indexOf(a.vnode) - vNodes.indexOf(b.vnode);
        });
    };
    const collect = (childInstance, childProvider) => {
        childInstances.push(childInstance);
        childProviders.push(childProvider);
        sortInstances();
    };
    const clear = (childInstance, childProvider) => {
        removeItem(childInstances, childInstance);
        removeItem(childProviders, childProvider);
    };
    const bindChildren = (parentProvider) => {
        provide(key, Object.assign({ childInstances,
            collect,
            clear }, parentProvider));
    };
    return {
        length,
        childProviders,
        bindChildren,
    };
}
